var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"time"},[_c('p',[_vm._v(_vm._s(_vm.trimmedTime))]),_c('span',{staticClass:"time-small"}),_c('span',{staticClass:"time-small"},[_vm._v(_vm._s(_vm.trimmedTime + ":30"))]),_c('span',{staticClass:"time-small"})])}
var staticRenderFns = []

export { render, staticRenderFns }